// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';

const MAX_GUESSES = 6;

const getDateSeed = () => {
  const today = new Date();
  return today.getUTCFullYear() * 10000 + (today.getUTCMonth() + 1) * 100 + today.getUTCDate();
};
const Footer = () => {
  return (
    <footer style={{ marginTop: '2rem', textAlign: 'center' }}>
      <p>
        Made with Prompting and <span role="img" aria-label="love">❤️</span> by{' '}
        <a href="https://insighttimer.com/sureshsrinivas" target="_blank" rel="noopener noreferrer">
          Suresh Srinivas
        </a>
        <br />
        <a href="mailto:ssuresh.srinivas@gmail.com">Email me</a> to provide feedback or{' '}
        <a href="https://wa.me/15036800616" target="_blank" rel="noopener noreferrer">
          send a WhatsApp message
        </a>
        <br />
        Special thanks to beta testers: Padma, Shilpa, Chaitra, Vaishali, Prasanna and many other G.I.F.T of Gita participants.
    <br />
    Assisted by <a href="https://www.openai.com/" target="_blank" rel="noopener noreferrer">OpenAI's ChatGPT</a>.
  </p>
    </footer>
  );
};

const GeetaWordle = () => {
  // State for the word list
  const [wordList, setWordList] = useState([]);

  // Game state
  const [word, setWord] = useState('');
  const [guess, setGuess] = useState('');
  const [guesses, setGuesses] = useState([]);
  const [feedback, setFeedback] = useState([]);
  // State for the game status

const [gameOver, setGameOver] = useState(false);
const [won, setWon] = useState(false);
const [history, setHistory] = useState([]);

useEffect(() => {
  fetch('/words.txt')
    .then((response) => response.text())
    .then((data) => {
      const words = data.trim().split('\n');
      setWordList(words);

      // Check if the stored date is different from the current date
      const currentDate = new Date();
      const storedDate = new Date(parseInt(localStorage.getItem('lastResetDate')));
      if (storedDate.toDateString() !== currentDate.toDateString()) {
        const wordIndex = getDateSeed() % words.length;
        setWord(words[wordIndex]);

        // Update the stored date in local storage
        localStorage.setItem('lastResetDate', currentDate.getTime().toString());
        localStorage.setItem('word', words[wordIndex]);
      } else {
        // Retrieve the stored word from local storage
        const storedWord = localStorage.getItem('word');
        if (storedWord) {
          setWord(storedWord);
        } else {
          const wordIndex = getDateSeed() % words.length;
          setWord(words[wordIndex]);
          localStorage.setItem('word', words[wordIndex]);
        }
      }
    });
}, []);


const revealAnswer = () => {
  setGameOver(true);
  setWon(false);
};

const handleSubmit = (e) => {
  e.preventDefault();

  // Convert the guess to uppercase
  const uppercaseGuess = guess.toUpperCase();

  // If the guess is empty or has already been submitted, do nothing
  if (!uppercaseGuess || guesses.includes(uppercaseGuess)) return;

  // Check if the guess is a valid word from the Gita words
  if (!wordList.includes(uppercaseGuess)) {
    alert('Please enter a valid Gita word.');
    setGuess('');
    return;
  }

  // Calculate the feedback for the guess
  let guessFeedback = Array(word.length).fill('⬜');
  let wordSeen = new Set();
  let guessSeen = new Set();

  for (let i = 0; i < uppercaseGuess.length; i++) {
    if (uppercaseGuess[i] === word[i]) {
      guessFeedback[i] = '🟩';
      wordSeen.add(i);
      guessSeen.add(i);
    }
  }

  for (let i = 0; i < uppercaseGuess.length; i++) {
    if (!guessSeen.has(i)) {
      for (let j = 0; j < word.length; j++) {
        if (!wordSeen.has(j) && uppercaseGuess[i] === word[j]) {
          guessFeedback[i] = '🟨';
          wordSeen.add(j);
          guessSeen.add(i);
          break;
        }
      }
    }
  }

  guessFeedback = guessFeedback.join('');

  // Update the game state with the new guess, feedback, and history
  setGuesses([...guesses, uppercaseGuess]);
  setFeedback([...feedback, guessFeedback]);
  setHistory([...history, `${uppercaseGuess} - ${guessFeedback}`]);

  // If the guess is correct or 6 guesses are over
  if (uppercaseGuess === word || guesses.length === 5) {
    if (uppercaseGuess === word) {
      setWon(true);
    } else {
      setGameOver(true);
    }
  }

  // Reset the guess input field
  setGuess('');
};

 


  
  const handleShare = () => {
    const feedbackString = feedback.join('\n');
    const shareData = {
      title: 'Geeta Wordle',
      text: `Check out my Geeta Wordle game progress:\n${feedbackString}`,
    };
  
    if (navigator.share) {
      navigator.share(shareData).catch((error) => console.error('Error sharing:', error));
    } else {
      console.error('Share API is not supported on this browser.');
    }
  };
  
  
  
  // Render the game board
  return (
    <div className="geeta-wordle">
      <h1>Geeta Wordle</h1>
      <p>
      GeetaWordle is a new word game that combines the fun of Wordle with the wisdom of the Bhagavad Gita. Each day,
      you'll be presented with a new five-letter word from the Bhagavad Gita, and you'll have six tries to guess it.
      But there's a twist: the words are all taken from the "Bhagavad Gita," one of the most important texts in
      Hinduism.
    </p>
    <p> Please use words from the Bhagavad Gita eg <b>KARMA</b> </p>
    <p>
    <span style={{ color: 'green' }}>Green</span> square: correct letter in the correct position.
    <br />
    <span style={{ color: 'yellow' }}>Yellow</span> square: correct letter but in the wrong position.
    <br />
    <span style={{ color: 'lightgray', border: '1px solid lightgray', padding: '2px' }}>White</span> square: incorrect letter not present in the word.
  </p>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={guess}
          onChange={(e) => setGuess(e.target.value)}
          maxLength={word.length}
          autoComplete="off"
        />
        <button type="submit">Submit</button>
      </form>
  
      {/* Render the previous guesses and feedback */}
<ul>
  {guesses.map((guess, index) => (
    <li key={index}>
      {guess} - {feedback[index]}
    </li>
  ))}
  {gameOver && (
    <li>
      <strong>Game over! The correct word was: {word}</strong>
    </li>
  )}
  {won && (
    <li>
      <strong>Congratulations! You guessed the word correctly!</strong>
    </li>
  )}
</ul>


  <button onClick={handleShare} style={{ marginTop: '1rem' }}>
    Share Game History
  </button>
  <p>
    To reveal today's answer click below.
  </p>
<button onClick={revealAnswer}>Geeta Wordle Today</button>
  
  <Footer />
    </div>
  );
};

export default GeetaWordle;
